import { QUERY_KEY } from "@/constant/queryKey";
import {
  adminCurrencyApi,
  AdminCurrencyDto,
} from "@/services/core/admin-currency.api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Hook for creating a admin currency
export function useCreateAdminCurrency() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AdminCurrencyDto) => adminCurrencyApi.create(data),
    onSuccess: () => {
      // Invalidate the currency list query to refetch data
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.ADMIN_CURRENCY] });
    },
  });
}

// Hook for updating a admin currency
export function useUpdateAdminCurrency() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: AdminCurrencyDto }) =>
      adminCurrencyApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.ADMIN_CURRENCY] });
    },
  });
}

// Hook for deleting a currency
export function useDeleteAdminCurrency() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => adminCurrencyApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.ADMIN_CURRENCY] });
    },
  });
}
